import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Observable, Subject } from 'rxjs';

export interface AberturaNoPainel {
  /** Rota da tela do portal a ser exibida no painel (ex.: '/configurar-menu'). */
  rota: string;
  /** Query params da navegação original (ex.: { idMenu: 5 }). */
  queryParams?: Params;
}

/**
 * Ponte entre as telas embutidas e o painel da tela de funcionalidades.
 *
 * Quando uma tela aberta no painel navega para outra tela do portal (ex.: de
 * "Cadastro de Menus" para "Configurar Menu"), o guard cancela a navegação e
 * avisa aqui — assim o usuário continua no painel, com o menu lateral, em vez
 * de sair para a rota isolada.
 */
@Injectable({
  providedIn: 'root',
})
export class PainelFuncionalidadesService {
  private readonly aberturaSubject = new Subject<AberturaNoPainel>();
  private ativo = false;

  readonly aberturas$: Observable<AberturaNoPainel> = this.aberturaSubject.asObservable();

  get painelAtivo(): boolean {
    return this.ativo;
  }

  registrarPainel(): void {
    this.ativo = true;
  }

  liberarPainel(): void {
    this.ativo = false;
  }

  abrir(rota: string, queryParams?: Params): void {
    this.aberturaSubject.next({ rota, queryParams });
  }
}
